import React from 'react';
import { StyleSheet, View } from 'react-native';
const html = require('../../../../../../applications/beacon/assets/html/PrivacyTerms.html');
const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});
export default function Privacy() {
    return (<View style={styles.container}>
      <div dangerouslySetInnerHTML={{ __html: html }}/>
    </View>);
}
//# sourceMappingURL=Privacy.web.js.map